const ua = window.navigator.userAgent.toLowerCase()

export const ios = /iphone|ipad|ipod/.test(ua)
export const android = /android/.test(ua)
export const qqnews = /qqnews/.test(ua)
export const weixin = /micromessager/.test(ua)
export const qqnewslite = /qqnewslite/.test(ua)
